import styles from "./styles.module.css";

export const SidebarEndcap = () => {
  return (
    <div className={styles.sidebarEndcap}></div>
  )
};

export default SidebarEndcap;
